import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import jwt_decode from 'jwt-decode'

import { specialIcashRefundAPI } from 'api/icash'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
import {
  specialIcashRefundTxFormTypes,
  specialIcashRefundTxFormSubmitValuesTypes,
  specialIcashRefundTxFormSubmitActionsTypes,
} from 'types/specialIcashRefundTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const INITIAL_VALUES: specialIcashRefundTxFormTypes = {
  creditValue: 0,
  externalTransactionId: '',
  ident: '',
  storeId: 0,
  deviceCode: '',
  cashier: '',
  guid: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const useSpecialIcashRefundTx = (
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  initialValues: specialIcashRefundTxFormTypes
  handleSubmitSpecialIcashRefundTx: (
    values: specialIcashRefundTxFormSubmitValuesTypes,
    actions: specialIcashRefundTxFormSubmitActionsTypes
  ) => void
} => {
  const authToken = ls.get(LSKEY_TOKEN)
  const decodedToken: { username: string } = jwt_decode(String(authToken))
  const member = useMemberStore((state) => state.member)
  const [initialValues] = useState<specialIcashRefundTxFormTypes>({
    ...INITIAL_VALUES,
    cashier: decodedToken?.username || '',
    ident: String(member?.cardNumber) || '',
  })

  const handleSubmitSpecialIcashRefundTx = useCallback(
    async (
      values: specialIcashRefundTxFormSubmitValuesTypes,
      actions: specialIcashRefundTxFormSubmitActionsTypes
    ) => {
      try {
        await specialIcashRefundAPI(values)
        toast.success('Special iCash refund successful.')
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
    },
    [onCloseModal]
  )

  return { member, initialValues, handleSubmitSpecialIcashRefundTx }
}